import { RouteConfig } from "vue-router";

const ordenes: RouteConfig = {
  path: "/ordenes",
  name: "ordenes",
  component: () => import(/* webpackChunkName: "ordenes" */ "@/views/Ordenes.vue"),
};

export default ordenes;
